import { render, staticRenderFns } from "./jx_step_bar.vue?vue&type=template&id=ba2896c8&scoped=true"
import script from "./jx_step_bar.vue?vue&type=script&lang=js"
export * from "./jx_step_bar.vue?vue&type=script&lang=js"
import style0 from "./jx_step_bar.vue?vue&type=style&index=0&id=ba2896c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2896c8",
  null
  
)

export default component.exports